export default __webpack_public_path__ + "static/media/abtJacqueline.bf05528a.jpg";